import { render, staticRenderFns } from "./PxCamposCompraItemTableSenior.vue?vue&type=template&id=0bb5b398&"
import script from "./PxCamposCompraItemTableSenior.vue?vue&type=script&lang=js&"
export * from "./PxCamposCompraItemTableSenior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports